import paper from './papers/DIP_  Una solución descentralizada para la gestión de proyectos y pagos.pdf'
const DIP = () => {
    return (
        <section id="portfolio-details" className="portfolio-details" style={{ marginTop: '5rem' }}>
            <div className="container">
                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="portfolio-description">
                            <h2>DIP : Decentralized Instant Payments</h2>
                            <p>
                                El proyecto DIP representa una innovadora solución descentralizada basada en la tecnología blockchain, diseñada específicamente para la gestión de proyectos y pagos entre compradores y proveedores de servicios. Su objetivo fundamental es ofrecer una plataforma transparente, fiable y equitativa para la gestión de pagos, eliminando la necesidad de confiar en una autoridad central o en ninguna de las partes involucradas.
                            </p>
                            <p>
                                Para lograr este propósito, el proyecto establece un conjunto de contratos inteligentes como el núcleo central del sistema. Estos contratos inteligentes definen y ejecutan automáticamente los términos y condiciones de los acuerdos entre las partes, lo que garantiza la transparencia y la ejecución justa de los pagos.
                            </p>
                            <p>
                                Además, el proyecto implementa un sólido protocolo de resolución de conflictos que asegura una gestión transparente y segura de los fondos del proyecto. Este protocolo permite abordar de manera eficaz cualquier disputa que pueda surgir entre las partes involucradas en el proceso.
                            </p>
                            <p>
                                Para facilitar la interacción entre los usuarios y los contratos inteligentes desplegados en la cadena de bloques, el proyecto cuenta con una aplicación dedicada. Esta aplicación proporciona una interfaz intuitiva y fácil de usar que permite a los usuarios gestionar sus proyectos y realizar transacciones de manera eficiente y segura.
                            </p>
                            <p>
                                Si desea conocer más sobre el proyecto, consulte el white paper que encontrará disponible en esta misma página.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="portfolio-info">
                            <h3>Información del Proyecto</h3>
                            <ul>
                                <li><strong>Categoria</strong>: Web3,Blockchain</li>
                                <li><strong>White Paper</strong> : <a href={paper} download>DIP Paper </a></li>
                                <li><strong>Fecha de inicio</strong>: 23 Juilio, 2023</li>
                                <li><strong>Github</strong>: <a href="https://github.com/MateuJP/DIP-Decentralized_Instant_Payments">DIP-Decentralized_Instant_Payments</a></li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )
}

export default DIP;
